import { storyblokEditable } from "@storyblok/react/rsc";

import { DotListItem } from "@/components/layout/DotListItem";
import { ListItemIcon } from "@/components/icons";
import { cn } from "@/lib/utils";

type InfoListItemIcon = "dot" | "check" | "none";
type IconColor = "default" | "sky-100";

const iconColorClasses: Record<IconColor, string> = {
  default: "",
  "sky-100": "text-sky-100",
};

type InfoListItemStoryblok = {
  text: string;
  icon?: InfoListItemIcon;
  icon_color?: IconColor;
  _uid: string;
  component: "info_list_item";
  [k: string]: any;
};

type InfoListItemProps = {
  blok: InfoListItemStoryblok;
};

const InfoListItem = ({ blok }: InfoListItemProps) => {
  const icon = blok.icon || "dot";
  const colorClass = blok.icon_color
    ? iconColorClasses[blok.icon_color as IconColor] || ""
    : "";

  if (icon === "check") {
    return (
      <div {...storyblokEditable(blok)}>
        <div className="flex items-center [&>*+*]:ml-3">
          <ListItemIcon
            name="check"
            className={cn("size-6 shrink-0", colorClass)}
          />
          <span className="flex-1 text-copy">{blok.text}</span>
        </div>
      </div>
    );
  }

  return (
    <div {...storyblokEditable(blok)}>
      <DotListItem dot={icon === "dot"}>{blok.text}</DotListItem>
    </div>
  );
};

export default InfoListItem;
